import { ridSegment } from '@krp/client-runtime'

/**
 * Адреса фото товаров 1С (срез RP-B2b, `PhotoEndpoints`). Кадр отдаётся
 * байтами с того же origin: `<img src>` несёт cookie сессии сам, transport
 * для показа не нужен.
 */
const products = (resourceId: string) => `/api/onec/v1/resources/${ridSegment(resourceId)}/catalog/products`
const product = (resourceId: string, refKey: string) => `${products(resourceId)}/${encodeURIComponent(refKey)}`

export const ONEC_PHOTO_URLS = {
  list: (resourceId: string, refKey: string) => `${product(resourceId, refKey)}/photos`,
  main: (resourceId: string, refKey: string) => `${product(resourceId, refKey)}/photo`,
  file: (resourceId: string, refKey: string, fileKey: string) =>
    `${product(resourceId, refKey)}/photo/${encodeURIComponent(fileKey)}`,
  present: (resourceId: string) => `${products(resourceId)}/photos-present`,
  setMain: (resourceId: string, refKey: string) => `${product(resourceId, refKey)}/main-photo`,
  /** Загрузка — multipart; `processed=false`: сырой снимок обрабатывает media на сервере. */
  upload: (resourceId: string, refKey: string) => `${product(resourceId, refKey)}/photo?processed=false`,
} as const

/** Главное фото товара по ключу 1С — для чужих экранов (поиск по фото Platform), которые показывают товар картинкой. */
export const onecProductPhotoUrl = (resourceId: string, refKey: string): string => ONEC_PHOTO_URLS.main(resourceId, refKey)
